export function emptySVG(): string {
  return "<g />";
}
